var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"download-app-wrap",on:{"click":_vm.download}},[_c('div',{staticClass:"btn"},[_vm._v("下载App")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/registry.npmmirror.com+vue-loader@13.7.3_4dfdbefe7f63f8fb6b22ea25d18a5c01/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ee43b32","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.pnpm/registry.npmmirror.com+vue-loader@13.7.3_4dfdbefe7f63f8fb6b22ea25d18a5c01/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/common/DownloadApp.vue
// module id = null
// module chunks = 